module.exports = __webpack_public_path__ + "img/app-icon-fake.e090b401.png";